import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollFieldsByUsageResponse, PayrollFieldsByUsageVariables } from '../types';

export const listFieldsByUsageQuery = gql`
  query PayrollFieldsByUsage(
    $usages: [PayrollFieldUsage!]!
    $section: String
    $pageSize: Int
    $pageToken: String
  ) {
    payrollFieldsByUsage(
      usages: $usages
      section: $section
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      definitions {
        id
        fieldKey
        label
        valueType
        origin
        enumValues
        usages
        filterable
        section
        groupKey
        displayOrder
      }
      pageInfo {
        total
        nextPageToken
        hasNext
      }
    }
  }
`;

export const listFieldsByUsage = (queryVariables: PayrollFieldsByUsageVariables) =>
  graphQLApi<PayrollFieldsByUsageResponse, PayrollFieldsByUsageVariables>({
    query: listFieldsByUsageQuery,
    queryVariables,
  });
